import { collection, where, query } from "firebase/firestore";
import { collectionPath } from "../context/EnvContext";

function getListingsCollection(db, ...rest) {
  return query(
    collection(db, `${collectionPath}Listings/ListingsList/DataBase`),
    where('listing_product_notAvailable', '==', false),
    ...rest,
  );
}


export default getListingsCollection;
